/* eslint-disable @typescript-eslint/no-explicit-any */
import { iterateEntries } from "../../../../../../../Common/IterableUtils";
import { fetchCors } from "../../../../../Engine/Api/FetchCors";

import type { Address, VerifyResult } from "./Types";
import type { Nullable } from "./Nullable";

const LIMIT = 50;

function getApiUrl(baseUrl: string): string {
    if (baseUrl.includes("testkontur") || baseUrl.includes("localhost")) {
        return "https://kladr.testkontur.ru/v1/";
    } else {
        return "https://kladr.kontur.ru/v1/";
    }
}

export function search(
    searchText: string,
    levels: string,
    parentCode: Nullable<string>,
    baseUrl: string
): Promise<Address[]> {
    const data = createQuery({
        prefix: searchText,
        parentKladr: parentCode || "",
        limit: LIMIT,
        desiredAoLevels: levels,
        strictSubordination: "false",
    });
    return fetchCors(`${getApiUrl(baseUrl)}suggest?${data}`)
        .then(res => res.json())
        .then(toJS)
        .then(removeEmpty);
}

export function removeEmpty(address: Address[]): Address[] {
    return address.filter(a => !Object.values(a).every(i => i === null));
}

export function verify(req: Address, baseUrl: string): Promise<VerifyResult> {
    return fetchCors(`${getApiUrl(baseUrl)}verify/`, {
        method: "POST",
        body: JSON.stringify(toJSON({ address: req })),
    })
        .then(res => res.json())
        .then(toJS);
}

function createQuery(data: { [name: string]: string | number | boolean }): string {
    const params = [];
    for (const [key, value] of iterateEntries(data)) {
        params.push(`${key}=${encodeURIComponent(value)}`);
    }
    return params.join("&");
}

function toJSON(obj: unknown): unknown {
    if (Array.isArray(obj)) {
        return obj.map(toJSON);
    } else if (obj && typeof obj === "object") {
        const ret = {};
        for (const key in obj) {
            // @ts-ignore
            ret[key.charAt(0).toUpperCase() + key.substr(1)] = toJSON(obj[key]);
        }
        return ret;
    }
    return obj;
}

function toJS(obj: unknown): any {
    if (Array.isArray(obj)) {
        return obj.map(toJS);
    } else if (obj && typeof obj === "object") {
        const ret = {};
        for (const key in obj) {
            // @ts-ignore
            ret[key.charAt(0).toLowerCase() + key.substr(1)] = toJS(obj[key]);
        }
        return ret;
    }
    return obj;
}
